import {sortShiftPropertiesPrimaryFirst} from "@/src/modules/shifts/lib/helpers";
import type {Shift} from "@/src/modules/shifts/types";

export function getShiftPrimaryPropertyGps(shift: Shift | null | undefined): string | null {
  if (!shift?.properties?.length) {
    return null;
  }

  const sorted = sortShiftPropertiesPrimaryFirst(shift.properties);
  const gps = (sorted[0]?.property as {gps_coordinates?: string | null} | undefined)
    ?.gps_coordinates;
  return gps?.trim() ? gps : null;
}
